import { createQuery } from '@shared/lib/query-helpers';

import {
  adminUserRoleAssignmentsSchema,
  adminUsersDirectorySchema,
  adminUsersSummarySchema,
  type AdminUserRoleAssignmentsResponse,
  type AdminUsersDirectoryResponse,
  type AdminUsersSummaryResponse,
} from './schemas';

export const adminUsersKeys = {
  all: ['admin-users'] as const,
  list: (page: number, search?: string, viewerId?: string) =>
    [
      ...adminUsersKeys.all,
      'list',
      { page, search: search ?? '', viewerId: viewerId ?? '' },
    ] as const,
  summary: (viewerId?: string) => [...adminUsersKeys.all, 'summary', viewerId ?? ''] as const,
  roleAssignments: (userId: string) => [...adminUsersKeys.all, 'role-assignments', userId] as const,
};

export function adminUsersPageQuery(page = 1, search?: string, enabled = true, viewerId?: string) {
  return createQuery<AdminUsersDirectoryResponse>({
    queryKey: adminUsersKeys.list(page, search, viewerId),
    path: '/api/v1/admin/users',
    schema: adminUsersDirectorySchema,
    enabled,
    // This read is viewer-scoped and idempotent. Preserving it across the development StrictMode
    // remount avoids cancelling and immediately restarting the same authenticated request.
    consumeAbortSignal: false,
    requestOptions: {
      params: {
        page,
        search,
      },
    },
  });
}

export function adminUsersSummaryQuery(enabled = true, viewerId?: string) {
  return createQuery<AdminUsersSummaryResponse>({
    queryKey: adminUsersKeys.summary(viewerId),
    path: '/api/v1/admin/users/summary',
    schema: adminUsersSummarySchema,
    enabled,
    // See adminUsersPageQuery: this remains one in-flight, viewer-scoped idempotent request.
    consumeAbortSignal: false,
  });
}

/** @deprecated Use adminUsersPageQuery. */
export const adminUsersDashboardQuery = adminUsersPageQuery;

export function adminUserRoleAssignmentsQuery(userId: string, enabled = true) {
  return createQuery<AdminUserRoleAssignmentsResponse>({
    queryKey: adminUsersKeys.roleAssignments(userId),
    path: `/api/v1/admin/users/${userId}/role-assignments`,
    schema: adminUserRoleAssignmentsSchema,
    enabled,
  });
}
